import React from "react";
import { Button} from "react-bootstrap";
import PageSizeSelector from "./PageSizeSelector";

const TablePaginationFooter = ({
  page,
  totalPages,
  totalElements,
  onPrev,
  onNext,
  pageSize,
  onPageSizeChange,
  pageSizeOptions = [],
}) => {
  const isFirstPage = page === 0;
  const isLastPage = page + 1 >= totalPages;
  return (
    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-3 px-2 py-2 border-top">
      <div className="d-flex align-items-center">
        {/* Page info */}
        <div className="mb-sm-0">
          <span className="text-sm text-secondary">
            {page + 1} to {totalPages} of {totalElements}
          </span>
        </div>

        {/* Left: Page size selector */}
        <div className="mb-2 mb-sm-0 d-flex align-items-center">
          <p className="mb-0 mx-2 text-sm">Rows per page:</p>
          <PageSizeSelector
            pageSize={pageSize}
            onChange={onPageSizeChange}
            options={pageSizeOptions}
          />
        </div>
      </div>

      {/* Navigation buttons */}
      <div className="d-flex align-items-center">
        <Button
          size="sm"
          variant="secondary"
          disabled={isFirstPage}
          onClick={onPrev}
        >
          Previous
        </Button>

        <Button
          size="sm"
          variant="primary"
          className="ms-2"
          disabled={isLastPage}
          onClick={onNext}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default TablePaginationFooter;